import { Input } from '@headlessui/react';
import type { FormFieldDto } from '../../form.types';
import { FIELD_CLASS } from './field.styles';

interface FormFieldColorProps {
    field: FormFieldDto;
}

export function FormFieldColor({ field }: FormFieldColorProps) {
    return (
        <Input
            name={field.name}
            required={field.required}
            defaultValue={field.options?.defaultValue}
            type="color"
            className={FIELD_CLASS}
        />
    );
}
